import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="errors"
// Used in: Page not found and server error pages
// Purpose: allow users to go back on click of button
export default class extends Controller {
  connect() {
    console.log('errors controller connected');
  }
  back() {
    history.back();
  }
}
